import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Input, InputGroup, Row, UncontrolledAlert, UncontrolledDropdown, UncontrolledTooltip } from "reactstrap";
import SimpleBar from "simplebar-react";
import EmojiPicker from "emoji-picker-react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import Spinners from "Components/Common/Spinner";

export interface Comment {
    from_user: string;
    time: string;
    text: string;
}

interface Props {
    comments: Comment[];
    loading: boolean;
    addNewComment: (newComment: string) => void;
}

export const CommentsBox: React.FC<Props> = ({ comments, loading, addNewComment }) => {

    const scrollRef = useRef<any>(null);

    const [isLoading, setLoading] = useState(loading)
    const [copyMsgAlert, setCopyMsgAlert] = useState<boolean>(false);
    const [isDisable, setDisable] = useState<boolean>(false);
    const [emoji, setEmoji] = useState<boolean>(false);
    const [selectedImage, setSelectedImage] = useState<string | null>(null);
    const [curComment, setCurComment] = useState<string>("");

    // scroll simple bar
    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.getScrollElement().scrollTop = scrollRef.current.getScrollElement().scrollHeight;
        }
    }, [comments])

    // copy msg
    const copyMsg = (ele: any) => {
        var copyText = ele.closest(".conversation-list").querySelector("p").innerHTML;
        navigator.clipboard.writeText(copyText);
        setCopyMsgAlert(true)
        if (copyText) {
            setTimeout(() => {
                setCopyMsgAlert(false)
            }, 1000)

        }
    };


    // emoji
    const [emojiArray, setEmojiArray] = useState<string[]>([]);
    const onEmojiClick = (event: any, emojiObject: any) => {
        setEmojiArray([...emojiArray, emojiObject.emoji]);
        setCurComment(curComment + event.emoji);
        setDisable(true)
    };


    // send msg
    const currentTime = new Date();
    const hours = currentTime.getHours();
    const minutes = currentTime.getMinutes();
    const time: any = `${hours}: ${minutes}`

    const addComment = async () => {
        if (curComment !== "" || selectedImage !== null) {
            await addNewComment(curComment);
            setCurComment("");
            setDisable(false)
            setEmoji(false);
            setSelectedImage(null)
        }
    };

    const onKeyPress = (e: any) => {
        const { key, value } = e;
        if (key === "Enter") {
            setCurComment(value);
            setDisable(true)
            addComment();
        }
    };

    return (
        <React.Fragment>
            <div className="w-100 user-chat">
                <Card>
                    <h4 className="card-title mb-4">Comments</h4>
                    <div>
                        <div className="chat-conversation p-3">
                            <SimpleBar ref={scrollRef} style={{ height: "470px" }}>
                                {isLoading ? <Spinners setLoading={setLoading} /> :
                                    <ul className="list-unstyled" id="users-conversation">
                                        {
                                            comments && (comments || [])?.map((comment: Comment, inx: number) => {
                                                return (
                                                    <React.Fragment key={inx}>
                                                        {
                                                            (
                                                                <li
                                                                    key={inx}
                                                                    className={"right"}
                                                                >
                                                                    <div className="conversation-list">
                                                                        <UncontrolledDropdown>
                                                                            <DropdownToggle href="#!" tag="a" className="dropdown-toggle">
                                                                                <i className="bx bx-dots-vertical-rounded" />
                                                                            </DropdownToggle>
                                                                            <DropdownMenu>
                                                                                <DropdownItem onClick={(e) => copyMsg(e.target)} href="#"> Copy</DropdownItem>
                                                                            </DropdownMenu>
                                                                        </UncontrolledDropdown>
                                                                        <div className="ctext-wrap">
                                                                            <div className="conversation-name">
                                                                                {comment.from_user}
                                                                            </div>
                                                                            <p>{comment.text}</p>
                                                                            {comment.time !== "0" && <p className="chat-time mb-0"><i className="bx bx-time-five align-middle me-1"></i>{comment.time}</p>}
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            )
                                                        }
                                                    </React.Fragment>)

                                            })
                                        }
                                    </ul>
                                }
                            </SimpleBar>
                        </div>
                        {
                            selectedImage &&
                            <div className="replymessage-block mb-0 d-flex align-items-start">
                                <div className="flex-grow-1">
                                    <img src={selectedImage} alt="select img" style={{ width: "150px", height: "auto" }} />
                                </div>
                                <div className="flex-shrink-0">
                                    <button type="button" id="close_toggle" className="btn btn-sm btn-link mt-n2 me-n3 fs-18" onClick={() => setSelectedImage(null)}>
                                        <i className="bx bx-x align-middle"></i>
                                    </button>
                                </div>
                            </div>
                        }

                        {copyMsgAlert && <UncontrolledAlert color='warning' role="alert">Comment copied</UncontrolledAlert>}
                        {emoji && <EmojiPicker onEmojiClick={onEmojiClick} width={250} height={382} />}

                        <div className="p-3 chat-input-section">
                            <Row>
                                <Col>
                                    <div className="position-relative">
                                        <Input type="text" value={curComment} onKeyPress={onKeyPress} onChange={e => { setCurComment(e.target.value); setDisable(true) }} className="chat-input" placeholder="Enter Comment..." />
                                    </div>
                                </Col>
                                <Col className="col-auto">
                                    <Button type="button" color="primary" disabled={!isDisable} onClick={() => addComment()} className="btn btn-primary btn-rounded chat-send w-md ">
                                        <span className="d-none d-sm-inline-block me-2"> Send</span>
                                        <i className="mdi mdi-send" />
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Card>
            </div>
        </React.Fragment>
    );
}